import { InferOutput, maxLength, pipe, string } from 'valibot'

export const HandleSchema = pipe(string(), maxLength(40))

export type Handle = InferOutput<typeof HandleSchema>
